/* eslint-disable no-unused-vars */
import React, { Fragment, useState, useCallback, useEffect, FormEvent, SetStateAction } from 'react';
import axios from 'axios';
import Footer from '../../../../Layout/Footer';
import { RegisterHeader } from '../../Components/Index';
import { BASE_URL_ADDR } from '../../../../Constants/BaseURL';
import { useNavigate, useParams } from 'react-router';
import "./PrintSlip.scss"
import psc from '../../../../Assets/images/psc_logo.png';
import police from '../../../../Assets/images/logo.png';
import nig_logo from '../../../../Assets/images/ng_flag_logo.png';
import { useVacancy } from '../../../../Hooks/getVacancy';
import { capitalize } from '../../../../Hooks';
const PrintSlip = () => {
  const { nin }: any = useParams<any>();
  const [refInput, setRefInput] = useState<string>(nin || "");
  const [loading, setLoading] = useState<boolean>(false);
  const [applicationResults, setApplicationResults] = useState<any>();
  const [workFlow, setWorkFlow] = useState<any>()
  const [applicationPayment, setApplicationPayment] = useState<any>();
  const [nimcRecord, setNimcRecord] = useState<any>({});
  const [qRcode, setQRCode] = useState('')
  const [error, setError] = useState<any>();
  const [requiredDox, setRequiredDox] = useState<string[]>([''])
  const { jobVacancyJsonz } = useVacancy()
  const [missingDox, setMissionDox] = useState<string[]>([''])
  const [availableDox, setAvailableDox] = useState<any>()
  const [comparisonOutp, setComparisonOut] = useState<boolean>(true)
  const [hidePrint, setHidePrint] = useState<boolean>(false)
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    preview();
  }
  const navigate = useNavigate();
  // console.log('JOB VACANCY:', jobVacancyJsonz)
  // const [<RiCalendarCheckFill />]
  // const location = useLocation()
  // const {submitInfo} = location.state
  const preview = async () => {
    setLoading(true);

    axios({
      timeout: 120000,
      method: 'GET',
      url: `${BASE_URL_ADDR}/recruitment/print-slip?nin=${refInput}`,
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json',
      },
    }).then(async response => {
      const data = response.data;
      // console.log("data", data);
      setQRCode(data.authQR)
      setNimcRecord(data.dataset.nimc)
      setApplicationResults({ photo: data.photo, ...data.dataset.formData });
      setWorkFlow(data.dataset.workflow)
      setApplicationPayment(data.metadata);
    }).catch(error => {
      console.log("data", error);
      setError(error?.response?.data?.message || "Application does no exist!");
    }).finally(() => {
      setLoading(false);
    })
  }

  const changeRef = useCallback((e: { target: { value: SetStateAction<string>; }; }): void => {
    setRefInput(e.target.value);
  }, [setRefInput]);

  const remarkChecker = () => {
    const roleType = applicationResults?.candidateRole || ''
    const workFlowManifest = workFlow?.formSubmission?.manifest || {}
    const documentType = jobVacancyJsonz?.dataset?.categoryAttribute.filter((document: any) => roleType in document)

    const requiredDocs = documentType[0][roleType].documentUpload
    const manifestDocs = Object.keys(workFlowManifest).map((doc) => doc === 'profession-certificate' ? 'professionalCertificate' : doc)
    const setJsonRecord = new Set(manifestDocs)
    const expectType = requiredDocs.filter((doc: string) => !setJsonRecord.has(doc === 'profession-certificate' ? 'professionalCertificate' : doc))
    // console.log('MAnifestINFO:', expectType)
    // console.log('SET')
    const output = requiredDocs.every((key: any) => setJsonRecord.has(key === 'profession-certificate' ? 'professionalCertificate' : key))
    // console.log('RequiredDocs:', output)
    setRequiredDox(requiredDocs)
    setMissionDox(expectType)
    setAvailableDox(setJsonRecord)
    setComparisonOut(output)
  }
  const checkIfTrue = (currentDocx: string) => {
    return availableDox?.has(currentDocx);
  }
  useEffect(() => {
    if (nin) {
      preview();
      return
    }
    if (applicationResults && applicationResults.candidateRole) {
      remarkChecker()
    }
    return () => { }
  }, [nin, applicationResults])
  // console.log(applicationResults)
  // console.log('ComparisonOUT:', comparisonOutp)
  const year = new Date(Date.now()).getFullYear();
  // console.log(year);

  // const Exam_Type: any = (applictionResult: any) => {
  //   if (applicationResults && applicationResults?.waec === true) {
  //     return "WAEC"
  //   }
  //   if (applicationResults && applicationResults?.neco === true) {
  //     return "NECO"
  //   }
  //   if (applicationResults && applicationResults?.nabteb === true) {
  //     return "NABTEB"
  //   }
  //   if (applicationResults && applicationResults?.gce === true) {
  //     return "GCE"
  //   }
  // }
  // console.log("QQQQ", qRcode);
  const formatText = (text: string) => {
    if (!text) return "";
    if (text === 'lgaCertificate') {
      return 'LGA Certificate'
    }
    if (text === 'ssce') {
      return text.toUpperCase()
    }
    return text
    // 1. Replace hyphens with spaces
      .replace(/-/g, ' ')
    // 2. Insert space before capital letters (e.g., "candidateRole" -> "candidate Role")
      .replace(/([a-z])([A-Z])/g, '$1 $2')
    // 3. Capitalize the first letter of each word
      .replace(/\b\w/g, char => char.toUpperCase());
  };

  const initPrint = () => {
    setHidePrint(true)
    setTimeout(() => {
      window.print()
      setHidePrint(false)
    }, 1000)
  }
  const goToManager = () => {
    navigate(`/document-manager/${refInput}`);
  }
  // const onChangeJobRole = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   const selectedRole = e.target.value;
  //   // Handle the selected job role as needed
  //   console.log("Selected Job Role:", selectedRole);
  // }
  return (
    <Fragment>
      <RegisterHeader />
      <main role="main" className="print--slip ">
{
          (!applicationResults) &&
          <div className="print-slip-request">
                <div className="print-slip-request__hero">
                    <div className="container">
                        <div className="print-slip-request__hero-content">
                            <h1 className="print-slip-request__title text-white">Print Your Confirmation Slip</h1>
                            <p className="print-slip-request__subtitle">
                                Enter your NIN to preview and print your application confirmation slip
                            </p>
                        </div>
                    </div>
                </div>

                <div className="print-slip-request__content mt-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-8 col-xl-7">
                                <div className="print-slip-request__card">
                                    <div className="print-slip-request__card-header">
                                        <h2 className="print-slip-request__card-title">Preview Your Slip</h2>
                                        <p className="print-slip-request__card-description">
                                            Enter your National Identification Number to view and print your confirmation slip.
                                        </p>
                                    </div>

                                    <form onSubmit={onSubmit} className="print-slip-request__form">
                                        {!nin && (
                                            <div className="print-slip-request__form-group">
                                                <label htmlFor="refid" className="print-slip-request__label">
                                                    <span className="print-slip-request__label-text">National Identification Number (NIN)</span>
                                                    <span className="print-slip-request__label-required">*</span>
                                                </label>
                                                <div className="print-slip-request__input-wrapper">
                                                    <svg className="print-slip-request__input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                        <circle cx="12" cy="7" r="4"></circle>
                                                    </svg>
                                                    <input
                                                        id="refid"
                                                        type="text"
                                                        className={`print-slip-request__input ${error ? 'print-slip-request__input--error' : ''}`}
                                                        onChange={changeRef}
                                                        value={refInput}
                                                        placeholder="Enter your 11-digit NIN"
                                                        disabled={loading}
                                                        aria-invalid={error
                                                          ? "true"
                                                          : "false"}
                                                        aria-describedby={error
                                                          ? "nin-error"
                                                          : undefined}
                                                    />
                                                </div>
                                                {error && (
                                                    <div id="nin-error" className="print-slip-request__error" role="alert">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <circle cx="12" cy="12" r="10"></circle>
                                                            <line x1="12" y1="8" x2="12" y2="12"></line>
                                                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                                        </svg>
                                                        <span>{error}</span>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        <div className="print-slip-request__form-actions">
                                            <button type="submit" className="print-slip-request__submit-btn" disabled={loading}>
                                                {loading
                                                  ? (
                                                    <>
                                                        <div className="spinner-border spinner-border-sm" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                        <span>Loading...</span>
                                                    </>
                                                    )
                                                  : (
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"></path>
                                                        </svg>
                                                        <span>Preview Slip</span>
                                                    </>
                                                    )}
                                            </button>
                                        </div>
                                    </form>

                                    <div className="print-slip-request__help">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                        </svg>
                                        <span>Please bring a copy of your confirmation slip to the screening venue.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          </div>
        }
        {
          (applicationResults) &&
          <section className="my-5">
            <div className="container">
              <div className="pb-5 mt-4 mb-3 bg-white shadow">
                <div className=" bg-primary rounded-top">
                  <div className=" w-100 float-left p-4 border-0 section-header-bg">
                    <div className="row h-100">
                      <div className="col-sm-3 my-auto text-center d-block d-lg-none">
                              <div className='d-flex px-5 position-relative v-w'>
          <div className='logo-style'>
            <img src={psc} width={60} height={60} className='rounded-pill' />
            <img src={police} width={60} height={60} className='rounded-pill' />
          </div>
          <div>
            <img
              src={nig_logo}
              width={150}
              height={150}
              className='rounded-pill ms-3'
            />
          </div>
        </div>
                      </div>
                                            <div className="col-sm-3 my-auto text-center d-none d-lg-block">

                        <img className="img-responsive border border-white rounded" width='120' height='120' src={`${applicationResults.photo || ''}`} />
                      </div>

                      <div className="col-sm-6 my-auto text-center">
                        <h2 className='text-light'> 2025 Nigeria Police Force Recruitment Application Confirmation Slip</h2>
                        <h4 className='text-light fw-bold py-4'>{(applicationResults?.surname || applicationResults?.surName)?.slice(0, 1).toUpperCase() + (applicationResults?.surname || applicationResults?.surName)?.slice(1).toLowerCase() || ''} {(applicationResults?.middlename || applicationResults?.middleName)?.slice(0, 1).toUpperCase() + (applicationResults?.middlename || applicationResults?.middleName)?.slice(1).toLowerCase() || ''}  {(applicationResults?.firstname || applicationResults?.firstName)?.slice(0, 1).toUpperCase() + (applicationResults?.firstname || applicationResults?.firstName)?.slice(1).toLowerCase() || ''}</h4>
                        <h6 className='text-light fw-bold'>NIN: {applicationResults?.nin}</h6>
                       {(applicationPayment.isQualified !== 0 && applicationResults?.referenceNo) && (<h6 className='text-light fw-bold'>Reference Number: {applicationResults?.referenceNo}</h6>)}
                      </div>
                          <div className="col-sm-3 my-auto text-center d-block d-lg-none">

                        <img className="img-responsive border border-white rounded" width='120' height='120' src={`${applicationResults.photo || ''}`} />
                      </div>
<div className="col-sm-3 my-auto text-center d-none d-lg-block">
                              <div className='d-flex px-5 position-relative v-w'>
          <div className='logo-style'>
            <img src={psc} width={60} height={60} className='rounded-pill' />
            <img src={police} width={60} height={60} className='rounded-pill' />
          </div>
          <div>
            <img
              src={nig_logo}
              width={150}
              height={150}
              className='rounded-pill ms-3'
            />
          </div>
        </div>
                      </div>

                    </div>
                  </div>
                </div>

                {applicationPayment?.isQualified === 1 ||
                <div className='container-fluid pt-2'>
                  <div className="row justify-content-center">
                    <div className="col-sm-6">
                      <div className='alert alert-danger text-center'>
                        <h2 className='fw-bolder'>FAILED RECRUITMENT APPLICATION</h2>
                        <div>{applicationResults?.pipelineStatusMessage}</div>
                        <div> {applicationPayment?.pipelineStatusMessage.map((message: any, index: number) => (
                          <div key={index} dangerouslySetInnerHTML={{ __html: message }} />
                        )

                        )
                        }</div>
                      </div>
                    </div>
                  </div>
                </div>}
                {applicationPayment && <div>
                  <div className='my-4 py-4'></div>
                  <div className='container pt-3'>
                    <table className='col-12 text-start mt-4 pt-5'>
                      <tbody className=''>
                        <tr className=''>
                          <th className="border p-1 pt-4">Application Status</th>
                          <th className="border p-1 pt-4">Candidate Role</th>
                          <th className="border p-1 pt-4">Rank</th>
                          {applicationResults.roleAttrib?.skillTitle && <th className="border p-1 pt-4">Skills</th>}
                        </tr>
                        <tr>
                        <th className="border p-1">{applicationPayment?.isQualified === 1 ? <span className='text-white bg-success p-2'>Qualified</span> : <span className='text-white bg-danger p-2'>Disqualified</span>}</th>
                          <th className="border p-1">{applicationResults.roleAttrib?.description}</th>
                          <th className="border p-1">{applicationResults.roleAttrib?.rank}</th>
                          {applicationResults.roleAttrib?.skillTitle && <th className="border p-1">{applicationResults.roleAttrib?.skillTitle}</th>}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>}

                  <div className='container'>
                    <div className='table-responsive'>
                      <table className="table float-left w-100 text-start h-5">
                        <tbody>
                          <tr>
                            <td>
                              <div>
                                <p style={{ fontSize: 18 }}><strong>Personal Information:</strong></p>
                              </div>
                              <div style={{ textAlign: 'start' }}>
                                <table className="text-start border-dark w-100" style={{ borderCollapse: 'collapse' }}>
                                  <tbody>
                                    <tr>
                                      <th className="border p-1">Name</th>
                                      <th className="border p-1">Gender</th>
                                      <th className="border p-1">DOB</th>
                                      <th className="border p-1">Marital status</th>
                                    </tr>
                                    <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.surname + ' ' + applicationResults?.firstname || ''}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.gender || ''}</td>
                                      <td className="border p-1" id="dob_view">{applicationResults?.age || ''}</td>
                                      <td className="border p-1" id="marital_status_view">{applicationResults?.maritalStatus || ''}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div>
                                <table className="text-start border-dark w-100" style={{ borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr>
                                      <th className="border p-1">Height</th>
                                      <th className="border p-1">Email</th>
                                      <th className="border p-1">Phone 1</th>
                                      <th className="border p-1">Phone 2</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="border p-1" id="meter">{`${applicationResults?.height} meter` || ''}</td>
                                      <td className="border p-1" id="email_view">{applicationResults?.email || ''}</td>
                                      <td className="border p-1" id="phone_1_view">{applicationResults?.phone || ''}</td>
                                      <td className="border p-1" id="phone_2_view">{applicationResults?.phone2 || ''}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                {applicationPayment?.isQualified === 1 && <>
                  <br />
                  <div className='container-fluid'>
                    <div className='table-responsive'>
                      <table className="table float-right border p-1 w-100">
                        <tbody>
                          <tr>
                            <td className="pl-1">
                              <p style={{ fontSize: 18 }}><strong>Next of Kin Information</strong></p>
                              <div style={{ textAlign: 'start' }}>
                                <table className="text-start border-dark w-100" style={{ borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr>
                                      <th className="border p-1">Name</th>
                                      <th className="border p-1">Phone</th>
                                      <th className="border p-1">Email</th>
                                      <th className="border p-1">Relationship</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.nextOfKinName || ''}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.nextOfKinPhone || ''}</td>
                                      <td className="border p-1" id="dob_view">{applicationResults?.nextOfKinEmail || ''}</td>
                                      <td className="border p-1" id="marital_status_view">{applicationResults?.nextOfKinRelationship || ''}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <br />

                  <div className='container-fluid mb-4'>
                    <table className="float-left p-1 w-100 mt-1 border">
                      <tbody>
                        <tr>
                          <td className="pl-2">
                            <p style={{ fontSize: 18 }}><strong> Permanent Address</strong></p>
                            <p><span id="permanent_state_view"><strong>State:</strong> {applicationResults?.stateOfPermanent}</span> </p>
                            <p><span id="permanent_lga_view"><strong>LGA:</strong> {applicationResults?.lgaOfPermanent}</span></p>
                            <p><span id="permanent_street_view"><strong>Street:</strong> {applicationResults?.streetAddressOfPermanent}</span></p>
                          </td>

                          <td>
                            <p style={{ fontSize: 18 }}><strong>Resident Address</strong></p>
                            <p><span id="resident_state_view"><strong>State:</strong> {applicationResults?.stateOfResidence}</span> </p>
                            <p><span id="resident_lga_view"><strong>LGA:</strong> {applicationResults?.lgaOfResidence}</span></p>
                            <p><span id="resident_street_view"><strong>Street: </strong>{applicationResults?.streetAddressOfResidence}</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className='container-fluid'>

                  </div>
                  <div className='container '>
                    <div className='table-responsive pt-2'>

                      <table className="table float-right border p-1 w-100">

                        <tbody>
                                                   <p style={{ fontSize: 18 }} className='p-2'><strong>First Sitting</strong></p>
                          <tr>
                            <td className="pl-1">
                              <div className={'row row-cols-lg-3 row-cols-2'}>
                                <div className={'col'}><p style={{ fontSize: 18 }}>Exam Type: <strong>{applicationResults.sscedetails[0].examType}</strong></p></div>
                                <div className={'col  me-auto'}><p style={{ fontSize: 18 }}>Exam Number: <strong>{applicationResults.sscedetails[0].examNo}</strong></p></div>
                                <div className={'col  me-auto'}><p style={{ fontSize: 18 }}>Exam Year: <strong>{applicationResults.sscedetails[0].examYear}</strong></p></div>
                              </div>

                              <div style={{ textAlign: 'start' }} >
                                <table className="text-start border-dark w-100" style={{ borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr>
                                      <th className="border p-1">Subject</th>
                                      <th className="border p-1">Grade</th>

                                    </tr>
                                  </thead>
                                  <tbody>
                                   {applicationResults?.firstSitting?.grade1 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject1 || "MATHEMATICS"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade1 || "-"}</td>

                                    </tr>}
                                    {applicationResults?.firstSitting?.grade2 &&
                                    <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject2 || "ENGLISH"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade2 || "-"}</td>

                                    </tr>}
                                   {applicationResults?.firstSitting?.grade3 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject3 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade3 || "-"}</td>

                                    </tr>}
                                   {applicationResults?.firstSitting?.grade4 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject4 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade4 || "-"}</td>

                                    </tr>}
                                   { applicationResults?.firstSitting?.grade5 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject5 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade5 || "-"}</td>

                                    </tr>}
                                    { applicationResults?.firstSitting?.grade6 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject6 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade6 || "-"}</td>

                                    </tr>}
                                   { applicationResults?.firstSitting?.grade7 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject7 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade7 || "-"}</td>

                                    </tr>}
                                    { applicationResults?.firstSitting?.grade8 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject8 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade8 || "-"}</td>

                                    </tr>}
                                    {applicationResults?.firstSitting?.grade9 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.firstSitting?.subject9 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.firstSitting?.grade9 || "-"}</td>
                                    </tr>}

                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                                    {applicationResults.sscedetails.length > 1 && <div className='container '>
                    <div className='table-responsive pt-2'>

                      <table className="table float-right border p-1 w-100">

                        <tbody>
                                                {applicationResults.sscedetails.length > 1 && <p style={{ fontSize: 18 }} className='pt-2'><strong>Second Sitting</strong></p> }
                          <tr>
                            <td className="pl-1">
                              <div className={'row row-cols-lg-3 row-cols-2'}>
                                <div className={'col'}><p style={{ fontSize: 18 }}>Exam Type: <strong>{applicationResults.sscedetails[1]?.examType}</strong></p></div>
                                <div className={'col  me-auto'}><p style={{ fontSize: 18 }}>Exam Number: <strong>{applicationResults.sscedetails[1]?.examNo}</strong></p></div>
                                <div className={'col  me-auto'}><p style={{ fontSize: 18 }}>Exam Year: <strong>{applicationResults.sscedetails[1]?.examYear}</strong></p></div>
                              </div>

                              <div style={{ textAlign: 'start' }}>
                                <table className="text-start border-dark w-100" style={{ borderCollapse: 'collapse' }}>
                                  <thead>
                                    <tr>
                                      <th className="border p-1">Subject</th>
                                      <th className="border p-1">Grade</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                   {applicationResults?.secondSitting?.grade1 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject1 || "MATHEMATICS"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade1 || "-"}</td>

                                    </tr>}
                                     {applicationResults?.secondSitting?.grade2 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject2 || "ENGLISH"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade2 || "-"}</td>

                                    </tr>}
                                    {applicationResults?.secondSitting?.grade3 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject3 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade3 || "-"}</td>

                                    </tr>}
                                     {applicationResults?.secondSitting?.grade4 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject4 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade4 || "-"}</td>

                                    </tr>}
                                     {applicationResults?.secondSitting?.grade5 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject5 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade5 || "-"}</td>

                                    </tr>}
                                     {applicationResults?.secondSitting?.grade6 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject6 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade6 || "-"}</td>

                                    </tr>}
                                     {applicationResults?.secondSitting?.grade7 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject7 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade7 || "-"}</td>

                                    </tr> }
                                    {applicationResults?.secondSitting?.grade8 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject8 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade8 || "-"}</td>

                                    </tr>}
                                     {applicationResults?.secondSitting?.grade9 && <tr>
                                      <td className="border p-1" id="name_view">{applicationResults?.secondSitting?.subject9 || "Unknown Subject"}</td>
                                      <td className="border p-1" id="gender_view">{applicationResults?.secondSitting?.grade9 || "-"}</td>
                                    </tr>}

                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>}
                  {/* <div className="container">
                     <p style={{ fontSize: 18 }} className='pt-2'><strong>Update Job Role</strong></p>
                     <div className=''>
                            <div><p className='text-danger'>By default, the job role will be set to the one you&asp;ve previously selected.</p></div>
                            <label className="form-label fw-bold text-muted  text-uppercase">Job Role</label>
                            <div>
                            <div className='d-flex gap-4'>
                            <input type='radio' className='form-check-input ' checked={true} readOnly />
                            <label>Leave Default</label>
                            </div>
                            <div>
                            <input type='radio' className='form-check-input ' checked={true} readOnly />
                            <label>Yes</label>
                            </div>
                            </div> */}
                            {/* <div className='d-flex justify-content-center'><select className='form-control w-50 custom-form-control' name='updateJobRole' onChange={onChangeJobRole}>
                              <optgroup>
                                <option>Leave Default</option>
                                <option value="yes">Yes</option>
                              </optgroup>
                            </select>
                            </div> */}
                      ÷
                  <div className='container'>
                     <p style={{ fontSize: 18 }} className='pt-2'><strong>Uploaded Document</strong></p>
                     <div className='row row-cols-lg-4 row-cols-sm-2 mx-4'>
                      {/* Hey */}
                          {
                            requiredDox.map((doc: string, index: number) => (
                               <div className="mb-3 form-check" key={index}>
                                <input type="checkbox" className="form-check-input" id={`check_${index}`} checked={checkIfTrue(doc === 'profession-certificate' ? 'professionalCertificate' : doc) || false} readOnly />
                                <label className="form-check-label" htmlFor={`check_${index}`}>{formatText(doc === 'profession-certificate' ? 'professionalCertificate' : doc)} </label>
                              </div>
                            ))
                          }
                     </div>
                     <hr/>
                  <div style={{ fontSize: 18 }} > <strong>Remark:</strong></div>
                  <div className='mx-5 border p-3 border-dark'>
                      <p><strong style={{ fontSize: 14 }} >Document Status:</strong> <span style={{ fontSize: '18px' }} className={comparisonOutp ? 'text-success' : 'text-danger'}><strong>Verification {comparisonOutp ? 'Successful' : 'Failed'}</strong></span></p>
                      <p><strong style={{ fontSize: 14 }} >Reason:</strong> <span>{comparisonOutp ? 'All required Document are uploaded' : `The following documents are missing:`}</span> {!comparisonOutp && <strong>{missingDox.map(doc => formatText(doc === 'profession-certificate' ? 'professionalCertificate' : doc).toUpperCase()).join(', ')}</strong>}</p>
                    {applicationResults?.stateOfPermanent === '' || applicationResults?.lgaOfPermanent === '' ? <p><strong style={{ fontSize: 14 }} >Biodata Status:</strong> <span style={{ fontSize: '18px' }} className={applicationResults?.stateOfPermanent !== '' && applicationResults?.lgaOfPermanent !== '' ? 'text-success' : 'text-danger'}><strong>Verification {applicationResults?.lgaOfPermanent !== '' || applicationResults?.lgaOfPermanent !== '' ? 'Successful' : 'Failed'}</strong></span></p> : null}
                      {(applicationResults?.stateOfPermanent === '' || applicationResults?.lgaOfPermanent === '') && <p><strong style={{ fontSize: 14 }} >Reason:</strong> <span>{(applicationResults?.stateOfPermanent !== '' || applicationResults?.lgaOfPermanent !== '') ? 'All required Document are uploaded' : `The following documents are missing:`}</span> {(applicationResults?.stateOfPermanent === '' || applicationResults?.lgaOfPermanent === '') && <strong>{ applicationResults?.lgaOfPermanent === '' && 'LGA of Permanent Address'}, { applicationResults?.stateOfPermanent === '' && 'State of Permanent Address'}</strong>}</p>}
                  </div>

                  </div>
                  <div className='d-flex justify-content-center'><img className="img-responsive" src={`data:image/png;base64, ${qRcode}`} width={200} height={200} alt='qrcode' /></div>
                  <div className="text-center h-4 mt-2 pt-3 border">
                    <div>Please come along with a copy of this form during the screening process and also a copy of your guarantor form</div>
                    <div>Nigeria Police Force Recruitment {year}</div>
                  </div>
                </>}
                <div className="text-center mt-5">
                 {!comparisonOutp || (applicationResults?.stateOfPermanent === '' || applicationResults?.lgaOfPermanent === '') ? <button className="btn w-25 btn-danger" onClick={() => goToManager()} >Update {(applicationResults?.stateOfPermanent === '' || applicationResults?.lgaOfPermanent === '') ? 'Documents/Informations' : 'Documents'}</button> : !hidePrint && <button className="btn w-25 btn-primary" onClick={() => initPrint()} >Print</button>}
                </div>
              </div>
            </div>
          </section>
        }
      </main>
      <Footer />
    </Fragment>
  );
}
export default PrintSlip;
